"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileExtensions = void 0;
const file_extension_1 = require("./model/file-extension");
exports.FileExtensions = {
    Forecast: new file_extension_1.FileExtension("3f"),
    Db: new file_extension_1.FileExtension("db")
};
//# sourceMappingURL=constants.js.map